import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { store } from 'store';
import { Toaster } from 'react-hot-toast';
import { ToastProvider } from '@hostfully/ui-components';
import { DesignSystemThemeProvider } from '@hostfully/ui-components/theme';

import GlobalStyles from 'styles/GlobalStyles';
import { queryClient } from 'queryClient';
import Router from './router';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/pages/calendar.css';
import 'i18n/setupInternationalization';
import 'utils/dragDropTouch/dragDropTouch';

const App = () => {
  return (
    <DesignSystemThemeProvider>
      <GlobalStyles />
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <Router />
          </Provider>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </ToastProvider>

      <Toaster
        position="bottom-left"
        reverseOrder={false}
        toastOptions={{ duration: 5000 }}
      />
    </DesignSystemThemeProvider>
  );
};

export default App;
